module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deleteAnnotationDialog.deleteAnnotationTitle":"Delete Annotation","deleteAnnotationDialog.deleteAnnotationSubtitle":"This action is not reversable, you will need to add a new annotation.","deleteAnnotationDialog.successfulDelete":"Annotation successfully deleted."}}')
  delete Component.options._Ctor
}
